/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalGenerationConfig,
  EvalGenerationConfig$inboundSchema,
  EvalGenerationConfig$Outbound,
  EvalGenerationConfig$outboundSchema,
} from "./evalgenerationconfig.js";

export type CreateEvalRunRequest = {
  suiteId: string;
  suiteVersion?: number | undefined;
  models: Array<string>;
  taskIds?: Array<string> | undefined;
  judgeModel?: string | undefined;
  embeddingModel?: string | undefined;
  generation?: EvalGenerationConfig | undefined;
  generationConcurrency?: number | undefined;
  concurrency?: number | undefined;
  graderConcurrency?: number | undefined;
  maxSamplesPerTask?: number | undefined;
  /**
   * Maximum sample-stage activity reservations per Temporal workflow execution before continuing as new.
   */
  maxWorkflowSampleActivities?: number | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateEvalRunRequest$inboundSchema: z.ZodType<
  CreateEvalRunRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  suite_id: z.string(),
  suite_version: z.number().int().optional(),
  models: z.array(z.string()),
  task_ids: z.array(z.string()).optional(),
  judge_model: z.string().optional(),
  embedding_model: z.string().optional(),
  generation: EvalGenerationConfig$inboundSchema.optional(),
  generation_concurrency: z.number().int().optional(),
  concurrency: z.number().int().optional(),
  grader_concurrency: z.number().int().optional(),
  max_samples_per_task: z.number().int().optional(),
  max_workflow_sample_activities: z.number().int().optional(),
  metadata: z.record(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "suite_version": "suiteVersion",
    "task_ids": "taskIds",
    "judge_model": "judgeModel",
    "embedding_model": "embeddingModel",
    "generation_concurrency": "generationConcurrency",
    "grader_concurrency": "graderConcurrency",
    "max_samples_per_task": "maxSamplesPerTask",
    "max_workflow_sample_activities": "maxWorkflowSampleActivities",
  });
});
/** @internal */
export type CreateEvalRunRequest$Outbound = {
  suite_id: string;
  suite_version?: number | undefined;
  models: Array<string>;
  task_ids?: Array<string> | undefined;
  judge_model?: string | undefined;
  embedding_model?: string | undefined;
  generation?: EvalGenerationConfig$Outbound | undefined;
  generation_concurrency?: number | undefined;
  concurrency?: number | undefined;
  grader_concurrency?: number | undefined;
  max_samples_per_task?: number | undefined;
  max_workflow_sample_activities?: number | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateEvalRunRequest$outboundSchema: z.ZodType<
  CreateEvalRunRequest$Outbound,
  z.ZodTypeDef,
  CreateEvalRunRequest
> = z.object({
  suiteId: z.string(),
  suiteVersion: z.number().int().optional(),
  models: z.array(z.string()),
  taskIds: z.array(z.string()).optional(),
  judgeModel: z.string().optional(),
  embeddingModel: z.string().optional(),
  generation: EvalGenerationConfig$outboundSchema.optional(),
  generationConcurrency: z.number().int().optional(),
  concurrency: z.number().int().optional(),
  graderConcurrency: z.number().int().optional(),
  maxSamplesPerTask: z.number().int().optional(),
  maxWorkflowSampleActivities: z.number().int().optional(),
  metadata: z.record(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    suiteVersion: "suite_version",
    taskIds: "task_ids",
    judgeModel: "judge_model",
    embeddingModel: "embedding_model",
    generationConcurrency: "generation_concurrency",
    graderConcurrency: "grader_concurrency",
    maxSamplesPerTask: "max_samples_per_task",
    maxWorkflowSampleActivities: "max_workflow_sample_activities",
  });
});

export function createEvalRunRequestToJSON(
  createEvalRunRequest: CreateEvalRunRequest,
): string {
  return JSON.stringify(
    CreateEvalRunRequest$outboundSchema.parse(createEvalRunRequest),
  );
}
export function createEvalRunRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateEvalRunRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateEvalRunRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateEvalRunRequest' from JSON`,
  );
}
